import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-check-auth',
  templateUrl: './check-auth.component.html',
  styleUrls: ['./check-auth.component.scss']
})

export class CheckAuthComponent implements OnInit {
  public logged_user = StorageService.getPerfilUsuario();
  public redirect_external = StorageService.getExternalAccess();

  constructor(private router: Router) { }
  ngOnInit() {
    if (this.logged_user) this.router.navigate(['/dashboard']);
    else if (this.redirect_external) this.router.navigateByUrl(this.redirect_external.destino);
    else this.router.navigate(['login']).then(() => {
      window.location.reload();
    });
  }
}